export { default } from './FareItemMediumSizeGrouped';
